<div class="container">
  <!-- Visually hidden H1 to satisfy “first level heading” and provide a page name -->
  <h1 class="visually-hidden">eCitation</h1>

  <!-- Site banner -->
  <div class="img banner" aria-label="Site banner">
    <img src="/assets/logo.png" alt="eCitation banner with Wisconsin Department of Justice Seal">eCitation
  </div>

  <!-- Header / navigation -->
  <app-ecitation-header id="header"></app-ecitation-header>

  <!-- Announcements/alerts should be announced politely to screen readers -->
  <div class="mt-2" aria-live="polite">
    <app-alert-notify></app-alert-notify>
  </div>

  <!-- Main content landmark for skip-to-main and SR navigation -->
  <div style="height:75.8vh;" class="d-flex flex-column justify-content-between" id="main-content"
    tabindex="-1">
    <div>
      <router-outlet></router-outlet>

      @if (getLocalStorage() && isSecured) {
        <div class="text-center">Logged in as:
          <span class="text-uppercase ">{{user}}</span>
        </div>
      }

      @if (getLocalStorage() && isSecured) {
        <div class="wijis_top_text">Restricted Technical Information</div>
      }
    </div>

    <div>
      <app-footer></app-footer>
    </div>
  </div>

  <app-loader></app-loader>
</div>